import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Home, MessageSquare } from "lucide-react";

export default function NotFound() {
  const location = useLocation();

  const askHailMary = () => {
    const attempted = location.pathname + location.search;
    window.dispatchEvent(
      new CustomEvent("hm:open-chat-with", {
        detail: {
          prompt: `I tried to visit ${attempted} but it doesn't exist. What did I mean?`,
        },
      }),
    );
  };

  return (
    <div
      className="min-h-[60vh] flex items-center justify-center p-6"
      data-testid="not-found-page"
    >
      <div className="max-w-md text-center">
        <div className="relative inline-flex items-center justify-center h-16 w-16 mb-6">
          <span className="absolute inline-flex h-full w-full rounded-full bg-hm-accent opacity-30 animate-ping" />
          <span className="relative inline-flex h-3 w-3 rounded-full bg-hm-accent" />
        </div>
        <div className="mono text-[10px] uppercase tracking-widest text-hm-fg-subtle mb-2">
          404 · off the map
        </div>
        <h1 className="text-3xl md:text-4xl text-hm-fg font-medium">This route doesn&apos;t exist</h1>
        <p className="text-sm text-hm-fg-muted mt-3 leading-relaxed">
          <code className="mono text-hm-fg">{location.pathname}</code> is not part of Hail Mary.
          Maybe you meant something else.
        </p>
        <div className="mt-8 flex items-center justify-center gap-3">
          <Link
            to="/dashboard"
            data-testid="notfound-home"
            className="inline-flex items-center gap-2 h-9 px-4 rounded-md bg-hm-bg-2 border border-hm-border hover:border-hm-border-strong text-sm text-hm-fg"
          >
            <Home className="h-4 w-4" />
            Dashboard
          </Link>
          <button
            onClick={askHailMary}
            data-testid="notfound-ask"
            className="inline-flex items-center gap-2 h-9 px-4 rounded-md bg-hm-accent text-hm-bg text-sm font-medium hover:bg-hm-accent-dim"
          >
            <MessageSquare className="h-4 w-4" />
            Ask Hail Mary
          </button>
        </div>
      </div>
    </div>
  );
}
